<template>
  <v-navigation-drawer permanent app :mini-variant="mini">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="title">
          {{ getUser.name }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list dense nav>
      <v-list-item
        v-for="(item, index) in items"
        :key="item.title"
        link
        @click.prevent="setItem(index)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      items: [
        { title: "Análise", icon: "mdi-image" },
        { title: "Histórico", icon: "mdi-help-box" },
        { title: "Mapa", icon: "mdi-map" }
      ],
      right: null
    };
  },
  computed: {
    ...mapGetters({
      getUser: "auth/getUser"
    }),
    mini() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  methods: {
    setItem(value) {
      this.$emit("emit-item", value);
    }
  }
};
</script>
